import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af0af97a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-us-block-wrap" }
const _hoisted_2 = { class: "contact-us-block" }
const _hoisted_3 = { class: "contact-us-block-title" }
const _hoisted_4 = { class: "contact-us-block-sub-title" }
const _hoisted_5 = { class: "contact-us-block-input" }
const _hoisted_6 = { class: "contact-us-block-textarea" }
const _hoisted_7 = { class: "contact-us-block-button-wrap" }
const _hoisted_8 = { class: "message-sended" }

import {PunpayInput, RunpayTextarea, WrapTitle} from "@/entities";
import {ref} from "vue";
import {UiButton, useLocalizationStore} from "@/shared";
import axios from "axios";
import { useVuelidate } from "@vuelidate/core";
import { required, email, minLength } from "@vuelidate/validators";
import { reactive, computed } from "vue";
import { useReCaptcha } from 'vue-recaptcha-v3';


export default /*#__PURE__*/_defineComponent({
  __name: 'contact-us',
  setup(__props) {

const {translate} = useLocalizationStore();
const token = ref("");
const sendEmailResponse = ref("");

const sendEmail = async () => {
  const appsettings = await fetch("/appsettings.json");
  const file = await appsettings.json();

  let response = await axios({
    method: "POST",
    url: file.ApiUrl + "/api/email/sendemail",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      EmailFrom: state.email,
      UserNameFrom: state.userName,
      Content: state.content,
      ReCaptchaToken: token.value
    }),
  });

  return response.data;
};

const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

const submitReCaptcha = async () => {
  await recaptchaLoaded()
  token.value = await executeRecaptcha('feedback')
};

const onClick = async () => {
  v$.value.$validate();

  if (!errorMessages.value.userNameError &&
    !errorMessages.value.emailError &&
    !errorMessages.value.contentError) {
    await submitReCaptcha();
    const response = await sendEmail();
    if(response === "ok!"){
      sendEmailResponse.value = translate("send_mail_success");
    }
    else{
      sendEmailResponse.value = translate("send_mail_failed");
    }
  }
  else{
    sendEmailResponse.value = "";
  }
};

const state = reactive({
  userName: '',
  email: '',
  content: '',
})

const rules = computed(() => {
  return {
    userName: { required, minLength: minLength(2) },
    email: { required, email },
    content: { required, minLength: minLength(5) }
  };
});

const v$ = useVuelidate(rules, state);

const errorMessages = computed(() => {
  const userNameError = v$.value.userName.$errors[0]
    ? v$.value.userName.$errors[0].$message
    : "";

  const emailError = v$.value.email.$errors[0]
    ? v$.value.email.$errors[0].$message
    : "";

  const contentError = v$.value.content.$errors[0]
    ? v$.value.content.$errors[0].$message
    : "";

  return {
    userNameError, emailError, contentError
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('contact_us_form'),
          size: "regular",
          weight: "700"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("contact_us_form_sub_title")), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(PunpayInput), {
          modelValue: state.userName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.userName) = $event)),
          label: _unref(translate)('name'),
          "error-message": errorMessages.value.userNameError
        }, null, 8, ["modelValue", "label", "error-message"]),
        _createVNode(_unref(PunpayInput), {
          modelValue: state.email,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.email) = $event)),
          label: _unref(translate)('email'),
          "error-message": errorMessages.value.emailError
        }, null, 8, ["modelValue", "label", "error-message"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(RunpayTextarea), {
          modelValue: state.content,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.content) = $event)),
          label: _unref(translate)('message'),
          placeholder: _unref(translate)('your_message'),
          "error-message": errorMessages.value.contentError
        }, null, 8, ["modelValue", "label", "placeholder", "error-message"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(UiButton), {
          class: "contact-us-button",
          color: "#71B92F",
          height: "45",
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)("send")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(sendEmailResponse.value), 1)
    ])
  ]))
}
}

})